import { CollapsibleCard, Skeleton } from '@teamsnap/snap-ui';
import * as React from 'react';

export function CollapsibleCardSkeleton() {
  return (
    <CollapsibleCard.Root open>
      <CollapsibleCard.Header>
        <Skeleton className="sui-w-[200px]" />
      </CollapsibleCard.Header>
      <CollapsibleCard.Content>
        <div className="sui-flex sui-justify-between sui-gap-1 sui-flex-col sui-pb-3">
          <Skeleton className="sui-w-[160px]" />
          <Skeleton className="sui-w-full" />
        </div>
        <div className="sui-flex sui-justify-between sui-gap-1 sui-flex-col sui-pb-3">
          <Skeleton className="sui-w-[230px]" />
          <Skeleton className="sui-w-full" />
        </div>
        <div className="sui-flex sui-justify-between sui-gap-1 sui-flex-col">
          <Skeleton className="sui-w-[120px]" />
          <Skeleton className="sui-w-full" />
        </div>
      </CollapsibleCard.Content>
    </CollapsibleCard.Root>
  );
}
